import { gql } from '@apollo/client';

export const FeatureFields = gql`
  fragment FeatureFields on Feature {
      _id
      name
      description
      outputSentence
      type
      maxValue
      minValue
      lowIsBetter
  }
`;

export const UserFeatureFields = gql`
  fragment UserFeatureFields on UserFeature {
    _id
    value
    interval {
      min
      max
      color
      logo
      label {
        name
        description
        descriptionForSurvey
        _id
      }
    }
  }
`;

export const FINISH_SURVEY = gql`
${UserFeatureFields}
${FeatureFields}
mutation createUserSurvey($input: UserSurveyCreateInput!) {
  createUserSurveyFeature(input: $input) {
    ...UserFeatureFields
    feature {
     ...FeatureFields
    }
    lastUserSurvey
  }
}
`;

export const FINISH_MATCHING_SURVEY = gql`
mutation endOfMatchingSurvey($input: UserSurveyCreateInput!) {
  endOfMatchingSurvey(input: $input) {
    isFound, 
    isManualMatchingSearchActive
    value {
      psychologist
      score
      ranking
      criteria {
        criteria
        score
        status
        label
        results {
            label
            matched
        }
        altResult
        shouldDisplayLabel
        shouldDisplayResults
        shouldDisplayAltResult
      }
    }
  }
}
`;
